module.exports = __webpack_public_path__ + "static/media/Montana2922.3bc2da9f.jpg";